<div class="flex gap-1 items-center">
  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isFirstDisabled()"
    (click)="handlePageChange(1)">
    <span class="icon-[mdi--skip-previous] size-5! text-base-content/60"></span>
  </button>
  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isFirstDisabled()"
    (click)="handlePageChange(pageNo() - 1)">
    <span class="icon-[mdi--chevron-left] size-5! text-base-content/60"></span>
  </button>

  @for (_page of pages(); track _page) {
    <button
      class="btn btn-sm min-w-9 h-9 rounded-lg font-medium px-0"
      [class.btn-primary]="pageNo() === _page"
      [class.btn-ghost]="pageNo() !== _page"
      (click)="handlePageChange(_page)">
      {{ _page }}
    </button>
  }

  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isLastDisabled()"
    (click)="handlePageChange(pageNo() + 1)">
    <span class="icon-[mdi--chevron-right] size-5! text-base-content/60"></span>
  </button>
  <button
    class="btn btn-ghost btn-sm min-w-9 h-9 rounded-lg px-0 disabled:bg-transparent disabled:opacity-30"
    [disabled]="isLastDisabled()"
    (click)="handlePageChange(pageInfo().totalPages || 1)">
    <span class="icon-[mdi--skip-next] size-5! text-base-content/60"></span>
  </button>
</div>
